import meadowBackground from '@/assets/images/login-meadow.jpg';

export const MEADOW_SCENE = {
  imageUrl: meadowBackground,
  objectPosition: '38% 62%',
  wash: 'radial-gradient(58% 55% at 50% 50%, rgba(244,237,217,0.26) 0%, rgba(244,237,217,0.04) 50%, rgba(27,28,21,0.16) 100%)',
};
